import React from 'react';

export const ICON_SHAPES = [
  { id:"circle",   label:"Cerchio",   render:(col)=><circle cx="12" cy="12" r="10" fill={col}/> },
  { id:"square",   label:"Quadrato",  render:(col)=><rect x="2" y="2" width="20" height="20" rx="4" fill={col}/> },
  { id:"triangle", label:"Triangolo", render:(col)=><polygon points="12,3 22,21 2,21" fill={col}/> },
  { id:"diamond",  label:"Diamante",  render:(col)=><polygon points="12,2 22,12 12,22 2,12" fill={col}/> },
  { id:"hexagon",  label:"Esagono",   render:(col)=><polygon points="12,2 20.66,6.5 20.66,17.5 12,22 3.34,17.5 3.34,6.5" fill={col}/> },
  { id:"ring",     label:"Anello",    render:(col)=><circle cx="12" cy="12" r="9" fill="none" stroke={col} strokeWidth="3"/> },
  { id:"shield",   label:"Scudo",     render:(col)=><path d="M12,2 L20,6 L20,13 Q20,19 12,22 Q4,19 4,13 L4,6 Z" fill={col}/> },
  { id:"drop",     label:"Goccia",    render:(col)=><path d="M12,3 C17,3 20,8 20,13 C20,18 16,21 12,21 C8,21 4,18 4,13 C4,8 7,3 12,3 Z" fill={col}/> },
];

export function SchedaIcon({id="circle", color="#007AFF", size=20}) {
  const shape = ICON_SHAPES.find(s => s.id === id) || ICON_SHAPES[0];
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" style={{display:"inline",verticalAlign:"middle",flexShrink:0}}>
      {shape.render(color)}
    </svg>
  );
}

export function getSchedaCustom(schedaId) {
  try { return JSON.parse(localStorage.getItem(`_sc_${schedaId}`)) || {}; }
  catch { return {}; }
}

export function setSchedaCustom(schedaId, updates) {
  const cur = getSchedaCustom(schedaId);
  localStorage.setItem(`_sc_${schedaId}`, JSON.stringify({...cur, ...updates}));
  window.dispatchEvent(new CustomEvent('schedaCustomChanged'));
}

// Color stored by name (stable across Supabase id changes)
export function getSchedaColor(name) {
  try { return localStorage.getItem(`_sccolor_${name}`) || null; }
  catch { return null; }
}
export function setSchedaColor(name, color) {
  if (color) localStorage.setItem(`_sccolor_${name}`, color);
  else localStorage.removeItem(`_sccolor_${name}`);
  window.dispatchEvent(new CustomEvent('schedaCustomChanged'));
}
